export class PDFWriter {
    constructor() {
        this.documents = {};
        this.errorText = 'The specified document does not exist.';
    }
    setLineWidth(id, lineWidth) {
        const document = this.getDocument(id);
        document.drawing.setLineWidth(lineWidth);
    }
    setColor(id, color) {
        const document = this.getDocument(id);
        document.drawing.setTextColor(color.r, color.g, color.b);
    }
    setScale(id, scale) {
        const document = this.getDocument(id);
        document.scale = scale;
    }
    newDocument(id, jsPDFDocument, scale = 1) {
        this.documents[id] = { drawing: jsPDFDocument, scale };
    }
    drawNamedLayer(id, plan, layerName, offsetX = 0, offsetY = 0) {
        if (!plan.plane)
            return;
        const layer = plan.plane.edges.edges[layerName];
        if (!layer)
            return;
        const coordinates = layer.generatorGeometry.attributes.position.array;
        this.draw(id, coordinates, offsetX, offsetY);
    }
    draw(id, coordinates, offsetX = 0, offsetY = 0) {
        const document = this.getDocument(id);
        const scale = document.scale;
        for (let i = 0; i < coordinates.length - 5; i += 6) {
            const start = [coordinates[i] * scale + offsetX, coordinates[i + 2] * scale + offsetY];
            const end = [coordinates[i + 3] * scale + offsetX, coordinates[i + 5] * scale + offsetY];
            // eslint-disable-next-line no-continue
            if (start[0] === 0 && start[1] === 0 && end[0] === 0 && end[1] === 0)
                continue;
            document.drawing.line(start[0], start[1], end[0], end[1], 'S');
        }
    }
    exportPDF(id, exportName) {
        const document = this.getDocument(id);
        document.drawing.save(exportName);
    }
    getDocument(id) {
        if (!this.documents[id])
            throw new Error(this.errorText);
        return this.documents[id];
    }
}
//# sourceMappingURL=pdf.js.map